<template>
  <div class="d-flex flex-column">
    <div class="grid-header">
      <h1>{{$t("comparaciones.titulo")}}</h1>
    </div>

    <DxDataGrid v-bind="getDefaultGridProperties()" :data-source="gridSource" ref="grid"
      class="dx-card wide-card grid-comparaciones">
      <DxColumnFixing :enabled="true" />
      <DxColumn data-field="DocumentoTitular" :caption="$t('comparaciones.grid.documento_titular')"></DxColumn> 
      <DxColumn data-field="TipoSuministro" :caption="$t('comparaciones.grid.suministro')">
        <DxLookup column-auto-width="true" v-bind="getLookup('rappels_mensuales', 'tipo_suministro')"></DxLookup>
      </DxColumn>
      <DxColumn data-field="Cups" :caption="$t('comparaciones.grid.cups')"></DxColumn> 
      <DxColumn data-field="FechaCreacion" :caption="$t('comparaciones.grid.fecha_creacion')" data-type="date" format="dd/MM/yyyy"></DxColumn>
      <DxColumn type="buttons" :caption="$t('comparador.grid.acciones')" :fixed="true"
        fixed-position="right" :buttons="[
          {
            cssClass: 'btn btn-link text-decoration-none btn-sm',
            icon: 'fa-regular fa-download text-success',
            hint: $t('comparador.grid.descargar_factura'),
            onClick: (e: any) => descargar(e.row.data.RutaDocumentoFactura)
          },
          {
            cssClass: 'btn btn-link text-decoration-none btn-sm',
            icon: 'fa-regular fa-download text-success',
            hint: $t('comparador.grid.descargar_comparativa'),
            onClick: (e: any) => descargar(e.row.data.RutaDocumentoComparacion),
            disabled: (options: any) => !options.row?.data.RutaDocumentoComparacion
          },
          {
            cssClass: 'btn btn-link text-decoration-none btn-sm',
            icon: 'fa-regular fa-magnifying-glass text-success',
            hint: $t('comparador.grid.ver_detalle'),
            onClick: (e: any) => verDetalle(e.row.data.Id, e.row.data.TipoSuministro)
          },
          {
            cssClass: 'btn btn-link text-decoration-none btn-sm',
            icon: 'fa-regular fa-plus text-success',
            hint: $t('comparador.grid.nueva_venta'),
            onClick: (e: any) => nuevaVenta(e.row.data.Id),
            visible: (options: any) => grupoUsuarioChecker.esColaborador()
          }
        ]"/>
    </DxDataGrid>
  </div>
</template>

<script setup lang="ts">
import { onMounted, ref } from "vue";
import { DxDataGrid, DxColumn, DxColumnFixing, DxLookup } from "devextreme-vue/data-grid";
import { getDefaultGridProperties } from "@helpers/grid-helper";
import { useApi } from "@api/integration";
import type CustomStore from "devextreme/data/custom_store";
import { useModalService } from "@services/modal-service";
import { type DXLoadOptions } from "@/.shared/.api";
import FileSaver from 'file-saver';
import { getLookup } from "@helpers/grid-helper";
import { useRouter } from "@/.shared/services/routing-services";
import { useIntl } from "@/.shared/services/i18n/i18nservice";
import ComparacionDetail from "@/components/comparaciones/ComparacionDetail.vue";
import { useGrupoUsuarioChecker } from "@/.shared/services/auth/authorization/grupo-usuario-checker";
import { TipoSuministroTramiteEnergiaEnum } from "@api/api";

const api = useApi();
const grid = ref<DxDataGrid>();
const gridSource = ref<CustomStore>();
const modal = useModalService();
const router = useRouter();
const intl = useIntl();
const grupoUsuarioChecker = useGrupoUsuarioChecker();

onMounted(async () => {
  setDataSource();
});

const setDataSource = async () => {

  gridSource.value = api.apiStore({
    key: "Id",
    load: async (p) => {
      const q = p as DXLoadOptions;
      return await api.callStandardApi("getComparacionesEnergiaAgenteForGrid", { showLoading: false }, q)
    }
  });
}

async function urlToBlob(ruta: string) {
  const response = await fetch(ruta);
  const data = await response.blob();
  const blob = new Blob([data], { type: "application/pdf;charset=utf-8" });
  return blob;
}

const descargar = async (ruta: string) => {
  var tempUrl = await api.callStandardApi("documentosGenerateTempUrl", {showLoading: false}, ruta);

  urlToBlob(tempUrl).then(blob => {
    try {
      var file = ruta.split('/').pop();
      FileSaver.saveAs(blob, file);
    }
    catch (error) {
      console.error('error', error);
    }
  });
}

const verDetalle = async (id: string, tipoSuministro?: TipoSuministroTramiteEnergiaEnum) => {
  let title = `${intl.i18n.t("comparador.detalle.titulo")}`;
  await modal.showModal(ComparacionDetail, { idComparacion: id, tipoSuministro }, { title: title })
  .then((value) => {
    if (value == "pdf-generated")
      grid.value?.instance?.refresh();
  });
}


const nuevaVenta = async (id: string) => {
  await router.push(intl.i18Route({ name: "nueva-venta", query: { idComparacion: id}}));
}

const refreshGrid = () => {
  grid.value?.instance?.refresh();
}

defineExpose({refreshGrid, verDetalle});

</script>

<style lang="scss" scoped>

</style>